import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    states: [],
};

const getters = {
    states: state => state.states,
};

const mutations = {
    setStates(state, data) {
        state.states = data;
    },
};

const actions = {
    async getStates({ commit, dispatch }) {
        let route = Laroute.route('franchise.vue.state');

        startLoading(dispatch, 'state');

        return axios
            .get(route)
            .then(res => {
                commit('setStates', res.data);
                endLoading(dispatch, 'state');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'state');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/state.js